export const comments = {
  add: 'Click here to add Optional Comments ',
  addpaired: 'Add a comment to this question',
  addsummary: 'Click here to add Optional Summary Comments ',
  remove: 'Remove comment',
};
